import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { LabReqBaseComponent } from '../lab-req-base/lab-req-base.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'app-lab-req-on',
  templateUrl: './lab-req-on.component.html',
  styleUrls: []
})
export class LabReqOnComponent extends LabReqBaseComponent implements OnInit {
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.syncGlucoseParent();
  }

  // Glucose has two sub-options (Fasting / Random). Checking either should
  // auto-check the parent "Glucose" checkbox to keep them in sync.
  private syncGlucoseParent() {
    const glucose = this.form.get('biochemistry_glucose');
    [
      'biochemistry_glucose_glucose_fasting',
      'biochemistry_glucose_glucose_random'
    ].forEach(controlName => {
      this.form
        .get(controlName)
        ?.valueChanges.pipe(takeWhile(() => this.active))
        .subscribe(checked => {
          if (checked && !glucose?.value) {
            glucose?.setValue(true);
          }
        });
    });
  }

  initForm() {
    this.form = this.fb.group({
      signature: [''],
      // Insurance
      insuranceType_OHIP: [false],
      insuranceType_ThirdParty: [false],
      insuranceType_WSIB: [false],
      // Admin
      clinicalInformation: [''],
      urgentContactNumber_contactNumber: [''],
      serviceDate: [''],
      otherProvincialRegistrationNumber: [''],
      copyTo_lastName: [''],
      copyTo_firstName: [''],
      copyTo_address: [''],
      // Biochemistry
      biochemistry_glucose: [false],
      biochemistry_glucose_glucose_random: [false],
      biochemistry_glucose_glucose_fasting: [false],
      biochemistry_hbA1C: [false],
      biochemistry_creatinine: [false],
      biochemistry_uricAcid: [false],
      biochemistry_sodium: [false],
      biochemistry_potassium: [false],
      biochemistry_alt: [false],
      biochemistry_alk: [false],
      biochemistry_bilirubin: [false],
      biochemistry_albumin: [false],
      biochemistry_lipid: [false],
      biochemistry_albuminCreatinine: [false],
      biochemistry_urinalysis: [false],
      biochemistry_neonatal: [false],
      biochemistry_child: [false],
      biochemistry_child_childAge_days: [''],
      biochemistry_child_childAge_hours: [''],
      biochemistry_child_clinicianTel: [''],
      biochemistry_child_patientTel: [''],
      biochemistry_therapeutic: [false],
      biochemistry_drugs: [false],
      biochemistry_drugs_name_1: [''],
      biochemistry_drugs_name_2: [''],
      biochemistry_drugs_lastDose_1: [''],
      biochemistry_drugs_lastDose_2: [''],
      biochemistry_drugs_nextDose_1: [''],
      biochemistry_drugs_nextDose_2: [''],
      biochemistry_drugs_time_collected_1: [''],
      biochemistry_drugs_time_collected_2: [''],
      // Hematology
      hematology_cbc: [false],
      hematology_prothrombinTime: [false],
      // Immunology
      immunology_pregnancy: [false],
      immunology_mononucleosis: [false],
      immunology_rubella: [false],
      immunology_prenatal: [false],
      immunology_repeatPrenatal: [false],
      // Microbiology
      microbiology_cervical: [false],
      microbiology_vaginal: [false],
      microbiology_vaginalRectal: [false],
      microbiology_chlamydia: [false],
      microbiology_chlamydia_desc: [''],
      microbiology_GC: [false],
      microbiology_GC_desc: [''],
      microbiology_sputum: [false],
      microbiology_throat: [false],
      microbiology_wound: [false],
      microbiology_wound_desc: [''],
      microbiology_urine: [false],
      microbiology_stoolCulture: [false],
      microbiology_stoolOva: [false],
      microbiology_otherSwabs: [false],
      microbiology_otherSwabs_desc: [''],
      // Specimen Collection
      specimenCollectionTime: [''],
      specimenCollectionDate: [''],
      // Viral Hepatitis
      viralHepatitis_acute: [false],
      viralHepatitis_chronic: [false],
      viralHepatitis_immuneStatus: [false],
      viralHepatitis_immuneStatus_hepatitisA: [false],
      viralHepatitis_immuneStatus_hepatitisB: [false],
      viralHepatitis_immuneStatus_hepatitisC: [false],
      // PSA
      psa_totalPSA: [false],
      psa_freePSA: [false],
      psa_insured: [false],
      psa_uninsured: [false],
      // Vitamin D
      vitaminD_insured: [false],
      vitaminD_uninsured: [false],
      // FOBT
      fobt_nonCCC: [false],
      fobt_CCC: [false],
      // Other Tests (object iterated by objectValues in HBS)
      otherTests_test: this.fb.group({
        t1: [''], t2: [''], t3: [''], t4: [''], t5: [''],
        t6: [''], t7: [''], t8: [''], t9: [''], t10: [''],
        t11: [''], t12: [''], t13: [''], t14: [''], t15: [''],
        t16: [''], t17: [''], t18: [''], t19: [''], t20: [''],
        t21: [''], t22: [''], t23: [''], t24: [''], t25: [''],
        t26: [''], t27: [''], t28: [''], t29: [''], t30: ['']
      }),
      lgvPaid_clientReference: [''],
      lgvPaid_danTalya: [true],
      lgvPaid_docFee: [true],
      lgvPaid_psa: [false],
      lgvPaid_shbg: [true],
      lgvPaid_vitaminD25: [true],
    });
  }
}
